import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery } from '@utils/styledTheme.util';

export const StyledMobileSection = styled(Box)`
  position: relative;
  width: 100vw;
`;

export const SliderContainer = styled.div`
  width: 100%;
  height: 1300px;
  display: flex;
  justify-content: top;
  flex-direction: column;
  position: relative;
  overflow: hidden;

  ${themeMediaQuery('below_sm')} {
    height: 1050px;
    margin-top: -65px;
  }
  ${themeMediaQuery('sm')} {
    height: 960px;
    margin-top: -128px;
  }
  ${themeMediaQuery('md')} {
    height: 1085px;
  }
  @media (min-width: 1400px) {
    height: 1115px;
  }
  ${themeMediaQuery('lg')} {
    height: 1200px;
  }
  ${themeMediaQuery('xl')} {
    height: 1330px;
  }
  @media (min-width: 1785px and max-width: 1800px) {
    height: 1385px;
  }
  @media (min-width: 1920px) {
    height: 1385px;
  }
  @media (min-width: 2100px) {
    height: 1425px;
  }
`;

export const SlideBackgroundImage = styled.div<{
  backgroundImage: string;
  backgroundImageMobile: string;
  backgroundColor: string;
}>`
  background: url(${(props) => cloudAssetUrl(props.backgroundImage, { optimization: 'none' })}) no-repeat;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100% auto;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: top;
  flex-direction: column;
  left: 0;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
  transition: opacity 2s ease-in-out;
  &.slideActive {
    opacity: 1;
    z-index: 1;
  }
  ${themeMediaQuery('below_sm')} {
    background-size: cover;
    background-image: url(${(props) => cloudAssetUrl(props.backgroundImageMobile)});
  }
  @media (min-width: 1920px) {
    background-position: center bottom;
    background-size: 100% auto;
  }
`;

export const RiskFreeReservationsWrapper = styled(Flex)`
  opacity: 0.9;
  border-radius: 27px;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    justify-content: center;
  }
  ${themeMediaQuery('sm')} {
    transform: scale(0.8);
  }
  ${themeMediaQuery('md')} {
    transform: scale(1);
  }
`;

export const BlogCenterTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 540px;
    font-size: 56px;
    line-height: 68px;
  }
  .text-pairing-body {
    max-width: 540px;
    font-size: 20px;
    line-height: 32px;
  }

  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      font-size: 40px;
      line-height: 46.88px;
    }
  }
`;

export const StyledBox = styled(Flex)`
  flex-direction: column;
  ${themeMediaQuery('below_sm')} {
    width: 100vw;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  ${themeMediaQuery('sm')} {
    width: max-content;
  }
`;
